module.exports = __webpack_public_path__ + "img/free-flowers.ec4f2917.png";